module.exports = __webpack_public_path__ + "static/media/69.88989993.svg";